
import Accounts from './accounts';

class User{
            constructor(params) {
            this.firstName;
            this.lastName;
            this.fullName;
            this.documents = [];
            this.id;
            this.perms = ["analytics","analytics-super-admin","analytics-owner"];
            this.roleOptions = [];
            this.roles = [];
            this.email;
            this.simpliad = {};
            this.emails = [];
            this.accounts = {};
            this.hasAccounts = [];
            this.refreshAccount = this.refreshAccount.bind(this);
            this.setParameters(params);
        
            
                }
             
            
            setParameters(params){
                    for (var prop in params){
                        if (params.hasOwnProperty(prop)){
                            var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                            if (this[method]){
                               this[prop] = this[method](params[prop]);
                            }
                            
                        }
                    }
        
                }

            
                setFirstName(val){
                    return val;
                }

                setLastName(val){
                    return val;
                }

                setFullName(val){
                    return val;
                }

                setId(val){
                    return val;
                }

                setAccounts(arr){
                    var accs = {};
                    arr.map((a) => {
                        var label = a.account.slice(0).toUpperCase() + a.account.slice(1);
                        accs[label] = accs[label] ? accs[label] : [];
                        accs[label].push(a);
                        this[label] = (this[label]) ? this[label] : [];
                        this[label].push(a);
                    });
                        this.accounts = accs;
                }

                setAccountTypeList(arr){
                    var ret = [];
                    arr.map((o) => {
                        var key = o.accountType.charAt(0).toUpperCase() + o.accountType.slice(1);
                        ret.push(new Accounts(o));
                    })
                    this.Networks = ret;
                    return ret;
    
                }
                set_sessionEmail(obj){
                    var ret = {email:obj.value};
                    var allSubAccounts = {};
                    this.email = obj.value;
                    if (obj._sessionAccounts){
                        
                    var allAccounts = this.recursiveAccounts(obj._sessionAccounts);
                 
                }
                    var al = {...ret,...allAccounts};
                    
                    return al;

                } 
                 recursiveAccounts = (_obj,accountType=false) => {
                    var response = {};
                        for (var o of _obj){
                            var key = (accountType) ? accountType : (o.accountType) ? o.accountType.charAt(0).toUpperCase() + o.accountType.slice(1) : false;
                                //key = (key == "Dashboard") ? "Network" : key;
                            if (key){
                            this.hasAccounts.push(key);
                            response[key] = (response[key]) ? response[key] : [];
                            var acc = new Accounts(o,this.refreshAccount);
                            for (var t of acc.getTypes()){
                                if (o[t]){
                                    acc = {...acc,...this.recursiveAccounts(o[t],t)};
                                }
                            }
                            delete acc["_types"];
                            response[key].push(acc);
                        }
                    }
                    if (Object.keys(response).length > 0){
                        return response;
                    }else{
                        return _obj;
                    }
                }

                refreshAccount(obj){
                   return new Accounts(obj,this.refreshAccount);
                 }


                refreshAccounts(obj){
                   var ret = {};
                   this.perms = (obj.perms) ? obj.perms : {};
                   delete obj["perms"];
                   if (obj.dashboards){
                    ret = new Accounts(obj);
                   }else{
                   ret = new Accounts(obj);
                   }
                    return ret.accounts;
                }
            }
            
        export default User;
                  